import React from 'react';

import {pure} from 'recompose';

import FaInfo from 'react-icons/lib/fa/info';
import FaVolumeOff from 'react-icons/lib/fa/volume-off';
import FaVolumeUp from 'react-icons/lib/fa/volume-up';

import Avatar from './Avatar.js';
import Bubble from './Bubble.js';
import CircleButton from './CirleButton.js';

import './Ai.css'

const avatarRadius = 300;
const bubbleMinimumRadius = 297;
const bubbleScale = 1.3;

const Ai = (props) => {
  const bubbleRadius = (props.audioAmp ** bubbleScale) + bubbleMinimumRadius;

  return (
    <div className="ai-container">
      <div className="ai" style={{width:avatarRadius}}>
        <div
          style={{
            position: 'relative',
          }}
        >
          <Avatar
            size={avatarRadius}
            for='ai'
            mx={0}
          />
          <Bubble
            radius={bubbleRadius}
            avatarRadius={avatarRadius}
            color={'#4fc3ea'}
            speed={'.08s'}
          />
          <Bubble
            radius={bubbleRadius * .9}
            avatarRadius={avatarRadius}
            color={'#00a8a2'}
            speed={'.05s'}
          />
        </div>
        <div className="ai-button-container">
          <CircleButton title="info">
            <FaInfo/>
          </CircleButton>
          <CircleButton
            title="mute"
            active={!props.sound}
            onClick={props.toggleSound}
          >
            {props.sound ?
                <FaVolumeUp /> :
                <FaVolumeOff />
            }
          </CircleButton>
        </div>
      </div>
    </div>
  )
};

export default pure(Ai);



// WEBPACK FOOTER //
// ./src/components/Ai.js